import InputHybrid from "./InputHybrid";

/**
 * Input component. Automatically routes between the Tailwind/CSS-class
 * implementation (preferred) and the styled-components implementation (for
 * consumers using system props or a styled() extension). The static
 * Input.ClearButton is preserved via the hybrid.
 */
export default InputHybrid;
export { InputHybrid as Input };
